// src/componance/DetailModalPropertyAdmin.js
import React from 'react';
import { Bed, Bath, Maximize,  MapPin, Home, FileText,  User  } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import PropertyMap from '../Map/PropertyMap'; // ✅ แก้ path ให้ถูกต้อง
import YouTubeEmbed from "./YouTubeEmbed";
const DetailModalPropertyAdmin = ({ selectedProperty, currency }) => {
  const { t } = useTranslation(); // ✅ ฟังก์ชันแปลภาษา

  if (!selectedProperty) return null;
 const propertyWithCoords = selectedProperty.latitude && selectedProperty.longitude
    ? [selectedProperty]
    : [];

  return (
    <div style={{ padding: '10px 0' }}>
      {/* Header */}
      <h2
        style={{
          marginBottom: '10px',
          color: '#fff',
          fontSize: '1.6rem',
          fontWeight: '700',
          borderBottom: '2px solid #eee',
          padding: '20px',
          backgroundColor: '#142438',
          borderRadius: '8px',
        }}
      >
        <span style={{ color: 'gold', fontWeight: 'bold' }}>SHA</span> ID : {selectedProperty.property_id} <br />
        {selectedProperty.name}
      </h2>

      {/* Property Details Box */}
      <div
        style={{
          border: '1px solid #ddd',
          borderRadius: '12px',
          padding: '20px',
          backgroundColor: '#fefefe',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          marginTop: '20px'
        }}
      >
        <h3
          style={{
            fontSize: '1.4rem',
            fontWeight: '700',
            color: '#1a2e35',
            borderBottom: '2px solid #eee',
            paddingBottom: '6px',
            marginBottom: '16px'
          }}
        >
          {t("Property Details")}
        </h3>

        {/* Grid Info */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: '15px',
        }}>
          <div className="flex items-center gap-2">
            <strong>{t("Price")} : </strong>
            {selectedProperty.price != null
              ? `${Number(selectedProperty.price).toLocaleString()} ${currency}`
              : '-'}
          </div>
          
          <div className="flex items-center gap-2">
            <MapPin size={16} /> <strong>{t("Location")} :</strong> {selectedProperty.location ? t(selectedProperty.location) : '-'}
          </div>
          <div className="flex items-center gap-2">
            <Home size={16} /> <strong>{t("Type")} :</strong> {selectedProperty.type ? t(selectedProperty.type) : '-'}
          </div>
          <div className="flex items-center gap-2">
            <FileText size={16} /> <strong>{t("Status")} :</strong> {selectedProperty.status ? t(selectedProperty.status) : '-'}
          </div>
          <div className="flex items-center gap-2">
            <Bed size={16} /> <strong>{t("Bedrooms")} :</strong> {selectedProperty.bedrooms ?? '-'}
          </div>
          <div className="flex items-center gap-2">
            <Bath size={16} /> <strong>{t("Bathrooms")} :</strong> {selectedProperty.bathrooms ?? '-'}
          </div>
           {/*    <div className="flex items-center gap-2">
            <ParkingCircle size={16} /> <strong>{t("Swimming Pool")} :</strong> {selectedProperty.swimmingPool ?? '-'} {t("m")}
          </div>   */}
          <div className="flex items-center gap-2 text-lg">
            <Maximize size={16} /> <strong>{t("Area")} :</strong> {selectedProperty.buildingArea ?? '-'} {t("sq.m")}
          </div>
           <div className="flex items-center gap-2 text-lg">
            <User  size={16} /> <strong>{t("Ownership")} :</strong> {selectedProperty.ownership ?? '-'}
          </div>
        {/*   <div className="flex items-center gap-2 text-lg">
            <Phone size={16} /> <strong>{t("Contact")} :</strong> {selectedProperty.contactInfo ?? '-'} 
          </div>*/}
          <div className="flex items-center gap-2 text-lg">
            <FileText size={16} /> <strong>{t("Remark")} :</strong> {selectedProperty.remark ?? '-'} 
          </div>
        </div>
        {selectedProperty.rentalEndDate   && (
        <span style={{
          backgroundColor: '#2ecc71',
          color: 'white',
          padding: '2px 6px',
          borderRadius: '6px',
          fontSize: '11px',
          fontWeight: 'bold'
        }}>
          🕒 {t('Until')}: {new Date(selectedProperty.rentalEndDate).toLocaleDateString()}
        </span>
      )}
        {/* Description */}
        <h2 style={{ marginTop: '20px' }}>{t('Description')}</h2>
        <div style={{
          marginTop: '20px',
          color: '#555',
          lineHeight: '1.8',
          fontSize: '1rem',
          textAlign: 'justify',
          padding: window.innerWidth > 768 ? '20px 40px' : '15px 20px',
          maxWidth: '800px',
          margin: '0 auto',
          backgroundColor: '#f9f9f9',
          borderRadius: '10px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          whiteSpace: 'pre-line',
        }}>
          {selectedProperty.description ? selectedProperty.description.substring(0, 1500) : '-'}
        </div>

     {selectedProperty.youtubeurl && (
        <YouTubeEmbed url={selectedProperty.youtubeurl} />
      )}
        {/* Map Section */}
       {/* Map Section */}
        <div style={{ marginTop: '30px', textAlign: 'center' }}>
        

          <div style={{
            width: '100%',
            maxWidth: '650px',
            height: '650px',
            margin: '0 auto',
            borderRadius: '12px',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
          }}>
            {/* ✅ ใช้เฉพาะทรัพย์สินที่เลือก */}
            <h1 style={styles.header}>{t('Map of Property')}</h1>
            <PropertyMap properties={propertyWithCoords} />
          </div>
        </div>
      </div>
    </div>
  );
};
const styles = {
  header: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '10px'
  },
};

export default DetailModalPropertyAdmin;
